import ImageGallerySlider from './components/image-gallery-slider';
import MediaContentSlider from './components/media-content-slider';

import ScrollWatcher from './util/scroll-watcher';

class App {
	constructor() {
		this.instances = {
			components: {
                imageGallerySlider: [],
				mediaContentSlider: []
			},
			blocks: {
			},
			scrollWatcher: null
		};

		this.init();
		this.initComponents();
		// this.initBlocks();
	}

	init() {

		this.scrollWatcher = new ScrollWatcher((params) => {
			ScrollWatcher.defaultCallback(params, 100);
		});

	}

	async initComponents() {

		// Image Gallery Slider
		Array.from(document.querySelectorAll('.block-image-gallery')).forEach(
			
			(imageGalleryBlock) => {
                this.slider = imageGalleryBlock.querySelector('.block-image-gallery__slider');
				this.nav = imageGalleryBlock.querySelector('.custom-nav-container-image-gallery');
                if (this.slider) {
                    this.instances.components.imageGallerySlider.push(
                        new ImageGallerySlider(this.slider, this.nav)
                    );
                }
			}
		);

		// Media Content Slider
		Array.from(document.querySelectorAll('.block-media-content__slider-wrapper')).forEach(
	
			(mediaContentSlider) => {
				this.slider = mediaContentSlider.querySelector('.block-media-content__slider');
				this.instances.components.mediaContentSlider.push(
					new MediaContentSlider(this.slider)
				);
			}
		);


	}


	async initBlocks() {
		
	}

}

export default App;
